// @flow

const getInitialRequestParams = (): {
  url: string,
  params: { per_page: number, by_format: string, later_than: string }
} => ({
  url: `articles`,
  params: {
    page: 1,
    per_page: 9,
    by_format: ''
  }
});

export default getInitialRequestParams;
